import ExcretionAnalysis from './Analysis'
import FormColumn from './column/Form'
import ColorColumn from './column/Color'

export default {
	ExcretionAnalysis,
	FormColumn,
	ColorColumn
}
